import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  categoryWrapper: {
    marginBottom: '3.8rem',
  },
  errorDisclaimer: {
    marginTop: '1rem',
    fontSize: '1.3rem',
    color: colors.red[600],
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
